import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/general/v3/'

// 列表
export const getPolicyList = (url,params) => axios({
  url: `${commonPath}${url}`,
  method: 'post',
  data: params
})

// 详情
export const getPolicyDetail = id => axios({
  url: `${commonPath}policy_templates/detail/${id}`,
  method: 'get'
})

// 新增
export const addPolicy = params => axios({
  url: `${commonPath}policy_templates/create`,
  method: 'post',
  data: params
})
// 编辑
export const editPolicy = params => axios({
  url: `${commonPath}policy_templates/update`,
  method: 'post',
  data: params
})

// 激活/归档
export const activePolicy = params => axios({
  url: `${commonPath}policy_templates/active`,
  method: 'patch',
  data: params
})

// 发布
export const publishPolicy = params => axios({
  url: `${commonPath}policy_templates/publish`,
  method: 'patch',
  data: params
})

// 服务域下拉
export const getGeneralSelectList = type => axios({
  url: `rest/store/general/v3/dictionaries/GetDicInfoListByType?type=${type}`,
  method: 'get'
})



// 列表
export const getTabRuleList = params => axios({
  url: `${commonPath}policy_templates_parameter/query`,
  method: 'post',
  data: params
})

// 新增
export const addTabRule = params => axios({
  url: `${commonPath}template_parameter_rel/create`,
  method: 'post',
  data: params
})
// 置顶
export const topTabRule = params => axios({
  url: `${commonPath}template_parameter_rel/top`,
  method: 'post',
  data: params
})

// 激活/归档
export const activeTabRule = params => axios({
  url: `${commonPath}template_parameter_rel/active`,
  method: 'patch',
  data: params
})




